var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1563 21.0002H0.843273C0.624589 20.9926 0.417378 20.9005 0.265339 20.7431C0.113301 20.5857 0.0283203 20.3755 0.0283203 20.1567C0.0283203 19.9379 0.113301 19.7276 0.265339 19.5702C0.417378 19.4129 0.624589 19.3207 0.843273 19.3132H20.1563C20.3801 19.3132 20.5948 19.4021 20.7531 19.5604C20.9114 19.7186 21.0003 19.9333 21.0003 20.1572C21.0003 20.381 20.9114 20.5957 20.7531 20.754C20.5948 20.9122 20.3801 21.0012 20.1563 21.0012V21.0002ZM5.14127 16.6082C5.01757 16.607 4.89605 16.5754 4.78744 16.5162C4.67883 16.4569 4.58646 16.3719 4.51847 16.2685C4.45049 16.1652 4.40898 16.0467 4.39761 15.9235C4.38624 15.8003 4.40536 15.6762 4.45327 15.5622L6.79227 10.0452C6.8295 9.95606 6.88348 9.87493 6.95127 9.80616L16.2613 0.500165C16.5787 0.184211 17.0084 0.00683594 17.4563 0.00683594C17.9042 0.00683594 18.3338 0.184211 18.6513 0.500165L20.5103 2.35016C20.8268 2.66753 21.0045 3.09745 21.0045 3.54567C21.0045 3.99388 20.8268 4.4238 20.5103 4.74117L11.2003 14.0502C11.1315 14.118 11.0504 14.1719 10.9613 14.2092L5.43827 16.5472C5.34435 16.5872 5.24336 16.6079 5.14127 16.6082ZM14.8083 4.33517L8.27427 10.8692L6.90927 14.0902L10.1293 12.7262L16.6643 6.19216L14.8083 4.33517ZM17.4593 1.68416L16.0003 3.14316L17.8573 5.00016L19.3103 3.54517L17.4583 1.68516L17.4593 1.68416Z",
    fill: "#163C68"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.474841d84148c7a48aaefa292a2ae464.svg";
export { ForwardRef as ReactComponent };